import {
  GenericNumericInputComponent,
  GenericDateIsoStringInputComponent,
  SelectOwnerDriverUserIdInputComponent,
  SelectTollAdminUserIdInputComponent,
  SelectTollManagerUserIdInputComponent,
  GenericDisabledTextInputComponent,
} from "./InputComponents";

export const truckDefinition = {
  id: {
    displayName: "ID",
    value: "",
    type: "string",
    displayValue: (entity) => String(entity.id),
    inputComponent: GenericDisabledTextInputComponent,
    isValid: (entity) => true,
  },

  truckId: {
    displayName: "Truck No.",
    displayValue: (entity) => String(entity.truckId),
    inputComponent: GenericNumericInputComponent,
    isValid: (entity) => Boolean(entity.truckId),
  },

  userId: {
    displayName: "Driver 1",
    displayValue: (entity) => String(entity.userId),
    inputComponent: SelectOwnerDriverUserIdInputComponent,
    isValid: (entity) => Boolean(entity.userId),
  },

  adminUserId: {
    displayName: "Admin 1",
    displayValue: (entity) => String(entity.adminUserId),
    inputComponent: SelectTollAdminUserIdInputComponent,
    isValid: (entity) => Boolean(entity.adminUserId),
  },

  managerUserId: {
    displayName: "Manager 1",
    displayValue: (entity) => String(entity.managerUserId),
    inputComponent: SelectTollManagerUserIdInputComponent,
    isValid: (entity) => Boolean(entity.managerUserId),
  },

  backupUserId: {
    displayName: "Driver 2",
    displayValue: (entity) => String(entity.backupUserId || ""),
    inputComponent: SelectOwnerDriverUserIdInputComponent,
    isValid: (entity) => true,
  },

  backupAdminUserId: {
    displayName: "Admin 2",
    displayValue: (entity) => String(entity.backupAdminUserId || ""),
    inputComponent: SelectTollAdminUserIdInputComponent,
    isValid: (entity) => true,
  },

  backupManagerUserId: {
    displayName: "Manager 2",
    displayValue: (entity) => String(entity.backupManagerUserId || ""),
    inputComponent: SelectTollManagerUserIdInputComponent,
    isValid: (entity) => true,
  },

  startDate: {
    displayName: "Start Date",
    displayValue: (entity) =>
      entity.startDate ? entity.startDate.split("T")[0] : "",
    inputComponent: GenericDateIsoStringInputComponent,
    isValid: (entity) => {
      if (entity.startDate && entity.endDate) {
        return entity.startDate <= entity.endDate;
      } else {
        return Boolean(entity.startDate);
      }
    },
  },

  endDate: {
    displayName: "End Date",
    displayValue: (entity) =>
      entity.endDate ? entity.endDate.split("T")[0] : "",
    inputComponent: GenericDateIsoStringInputComponent,
    isValid: (entity) => {
      if (entity.startDate && entity.endDate) {
        return entity.startDate <= entity.endDate;
      } else {
        return true;
      }
    },
  },
};

export const columns = [
  // "id",
  "truckId",
  "userId",
  "adminUserId",
  "managerUserId",
  "backupUserId",
  "backupAdminUserId",
  "backupManagerUserId",
  "startDate",
  "endDate",
];

export const defaultTruck = {
  id: 0,
  truckId: undefined,
  userId: undefined,
  adminUserId: undefined,
  managerUserId: undefined,
  backupUserId: undefined,
  backupAdminUserId: undefined,
  backupManagerUserId: undefined,
  startDate: undefined,
  endDate: undefined,
};
